export const required = '{1} is required';
export const minLength = '{1} must be at least {2} characters long.';
export const maxLength = 'Please enter no more than {2} characters.';
export const exactLength = 'Field must be {1} characters long.';
export const minValue = 'Please enter a value greater than or equal to {1}.';
export const maxValue = 'Please enter a value less than or equal to {1}.';
export const between = 'Please enter a value between {1} and {2}.';
export const alpha = 'Please enter a valid letter.';
export const alphaNum = 'Please enter a valid letter or number';
export const numeric = 'Please enter a valid number.';
export const integer = 'Please enter a valid whole number.';
export const decimal = 'Please enter a valid decimal number.';
export const email = 'Please enter a valid email address.';
export const ipAddress = 'Please enter a valid IP address.';
export const macAddress = 'Please enter a valid MAC address.';
export const sameAs = 'Field must equal to {1} field.';
export const url = 'Please enter a valid URL.';
export const or = 'Field must match {1} or {2}.';
export const and = 'Field must match {1} and {2}.';
export const not = '{1} can not equal {2}.';
export const hasUpper = 'Field must have at least 1 uppercase character.';
export const noUpper = 'Uppercase characters are not permitted for this field.';
export const hasLower = 'Field must have at least 1 lowercase character.';
export const hasNumber = 'Field must have at least 1 numeric character.';
export const hasSpecialCharacter = 'Field must have at least 1 special character.';
export const dateFormat = 'Field must be a valid date in {1} format.';
export const validUsername = 'Usernames can only contain letters numbers and dashes.';
export const usernameAvailable = 'That username is not available.';
export const tenDigitPhone = 'Please enter a valid 10-digit phone number.';
export const routingNumber = 'Invalid routing number.';
export const routingNumberDoesNotMatchFi = 'Routing number does not match {1}';
export const currency = 'Invalid value, please limit to a number with 2 decimal places.';
export const invalidFtpHost = 'Invalid ftp host. Example: ftp.host.com:21[/file/path]';
